<template>
  <div class="row">
    <div class="col">
      <div class="mt-2 ml-6">
        <a
          href="#"
          v-show="editmode != true"
          @click="saveField"
          class="bg-green-500 text-white text-xs hover:bg-green-700 hover:no-underline rounded link-btn-style"
          >Save</a
        >
        <a
          href="#"
          v-show="editmode"
          @click="updateField"
          class="bg-green-500 text-white text-xs hover:bg-green-700 hover:no-underline rounded link-btn-style"
          >Update</a
        >
        <a
          @click="cancel"
          href="#"
          class="bg-gray-500 text-white text-xs hover:bg-gray-700 hover:no-underline ml-3 rounded link-btn-style"
          >Cancel</a
        >
        <a
          v-show="editmode"
          href="#"
          @click="deletefld"
          class="bg-red-500 text-white text-xs hover:bg-red-700 hover:no-underline ml-3 rounded link-btn-style"
          >Delete</a
        >
      </div>

      <!-- <div class="pull-right">
        <a class="btn btn-success" href="#" @click="saveField">Save</a>
        <a class="btn btn-success" href="#" @click="cancel">Cancel</a>
        <a class="btn" href="#" @click="deletefld" v-show="editmode">Delete</a>
      </div> -->

      <br />
      <form class="form-horizontal">
        <div class="form-group form-inline">
          <label class="col-md-2">Data Type:</label>
          <select
            id="type"
            v-model="formdata.editorType"
            @change="onChange($event)"
            class="form-control form-control-sm col-md-4 col-sm-4"
            :disabled="editmode"
          >
            <option value="dxTextBox">TextField</option>
            <option value="dxCheckBox">CheckBox</option>
            <option value="Currency">Currency</option>
            <option value="dxDateBox">Date</option>
            <option value="Datetime">Datetime</option>
            <option value="Time">Time</option>
            <option value="Decimal">Decimal</option>
            <option value="dxSelectBox">Dropdown</option>
            <option value="Float">Float</option>
            <option value="Integer">Integer</option>
            <option value="MultiSelect">MultiSelect</option>
            <option value="Phone">Phone</option>
            <option value="Relate">Relate</option>
            <option value="Json">Json</option>
            <option value="dxTextArea">TextArea</option>
            <option value="dxAutocomplete">AutoComplete</option>
            <option value="InvoiceField">InvoiceField</option>
            <option value="LineItemField">LineItemField</option>
            <option value="TransactionField">TransactionField</option>
            <option value="RelateDependentField">RelateDependentField</option>
            <option value="BatchDialogField">BatchDialogField</option>
            <option value="ReportField">ReportField</option>

          </select>
        </div>
        <!-- common fields -->
        <div class="form-group form-inline">
          <label class="col-md-2">Field Name:</label>
          <input
            class="form-control form-control-sm col-md-4"
            v-model="formdata.name"
            @input="getfieldName"
            @focusout="getfieldName"
            @keydown.space.prevent
            type="text"
            style="text-transform: lowercase"
            :disabled="editmode || nameDisable ? true : false"
          />
        </div>

        <div class="form-group form-inline">
          <label class="col-md-2">Display Label:</label>
          <input
            class="form-control form-control-sm col-md-4"
            v-model="formdata.label"
            type="text"
          />
        </div>

        <div class="form-group form-inline">
          <label class="col-md-2">System Label:</label>
          <input
            class="form-control form-control-sm col-md-4"
            readonly
            v-model="formdata.vname"
            type="text"
          />
        </div>

        <div class="form-group form-inline">
          <label class="col-md-2">Help Text:</label>
          <input
            class="form-control form-control-sm col-md-4"
            v-model="formdata.helpText"
            type="text"
          />
        </div>
        <!-- common view for Default Value -->
        <div
          v-show="Currency || TextField || Json || Decimal || Float || Integer"
        >
          <div class="form-group form-inline">
            <label class="col-md-2">Default Value:</label>
            <input
              class="form-control form-control-sm col-md-4"
              v-model="formdata.editorOptions.value"
              type="text"
            />
          </div>
        </div>

        <!-- text view -->
        <div v-show="TextField || Json || Decimal || Float || Integer">
          <div class="form-group form-inline">
            <label class="col-md-2">Max Size:</label>
            <input
              class="form-control form-control-sm col-md-4"
              v-model="formdata.len"
              type="text"
            />
          </div>
        </div>
        <!-- Checkbox view -->
        <div v-show="Checkbox">
          <div class="form-group form-inline">
            <label class="col-md-2">Default Value:</label>
            <input
              class="styled-checkbox"
              id="styled-checkbox-1"
              v-model="formdata.editorOptions.value"
              type="checkbox"
              value="value1"
            />
            <label for="styled-checkbox-1"></label>
          </div>
        </div>
        <!-- Currency view -->
        <div v-show="Currency || Decimal || Float || Integer">
          <div class="form-group form-inline">
            <label class="col-md-2">Enable Range Search:</label>
            <input
              class="styled-checkbox"
              id="styled-checkbox-2"
              v-model="formdata.enable_range_search"
              type="checkbox"
            />
            <label for="styled-checkbox-2"></label>
          </div>
        </div>

        <!--DependentDropdown-->
        <div v-show="RelateDependentField">
          <div class="form-group form-inline">
            <label class="col-md-2">Dependent On:</label>
            <div>
              <DxSelectBox
                v-model="formdata.dependentOn"
                :search-enabled="true"
                :data-source="dependentOnList"
                :search-mode="searchModeOption"
                :search-expr="searchExprOption"
                :search-timeout="searchTimeoutOption"
                :min-search-length="minSearchLengthOption"
                :show-data-before-search="showDataBeforeSearchOption"
                display-expr="label"
                value-expr="rmodule"
                width="395"
                height="33"
                :disabled="editmode"
                @value-changed="onDependentValueChanged"
              />
            </div>
          </div>

          <div class="form-group form-inline">
            <label class="col-md-2">Dependent Module:</label>

            <div>
              <DxSelectBox
                v-model="formdata.depedentModule"
                :search-enabled="true"
                :data-source="dependentModuleList"
                :search-mode="searchModeOption"
                :search-expr="searchExprOption"
                :search-timeout="searchTimeoutOption"
                :min-search-length="minSearchLengthOption"
                :show-data-before-search="showDataBeforeSearchOption"
                display-expr="label"
                value-expr="value"
                width="395"
                height="33"
              />
            </div>
          </div>
        </div>

        <!-- Date view -->
        <div v-show="Date_tp || Datetime">
          <div class="form-group form-inline">
            <label class="col-md-2">Default Value:</label>
            <select
              class="form-control form-control-sm col-md-4"
              v-model="formdata.default"
            >
              <option label="-none-" value="">-none-</option>
              <option label="yesterday" value="-1 day">yesterday</option>
              <option label="today" value="now">today</option>
              <option label="tomorrow" value="+1 day">tomorrow</option>
              <option label="next week" value="+1 week">next week</option>
              <option label="next monday" value="next monday">
                next monday
              </option>
              <option label="next friday" value="next friday">
                next friday
              </option>
              <option label="two weeks" value="+2 weeks">two weeks</option>
              <option label="next month" value="+1 month">next month</option>
              <option
                label="first day of next month"
                value="first day of next month"
              >
                first day of next month
              </option>
              <option label="three months" value="+3 months">
                three months
              </option>
              <option label="six months" value="+6 months">six months</option>
              <option label="next year" value="+1 year">next year</option>
            </select>
          </div>
        </div>
        <!--  -->
        <div v-show="Decimal || Float || Integer">
          <div class="form-group form-inline">
            <label class="col-md-2">Precision:</label>
            <input
              class="form-control form-control-sm col-md-4"
              v-model="formdata.editorOptions.precision"
              type="text"
            />
          </div>
        </div>
        <div v-show="Dropdown || MultiSelect">
          <div class="form-group form-inline">
            <label class="col-md-2">Drop Down List:</label>
            <select
              class="form-control form-control-sm col-md-4"
              v-model="formdata.options"
              @change="getDropdown()"
            >
              <option value="0" disabled>Select Dropdown</option>
              <option
                v-for="ddls in DD_List"
                :value="ddls.name"
                v-bind:key="ddls.name"
              >
                {{ ddls.name }}
              </option>
            </select>
            <a
              @click="editdropdown"
              href="#"
              class="bg-gray-500 text-white text-xs hover:bg-gray-700 hover:no-underline ml-3 rounded link-btn-style"
              >Edit</a
            >
            <a
              @click="adddropdown"
              href="#"
              class="bg-gray-500 text-white text-xs hover:bg-gray-700 hover:no-underline ml-3 rounded link-btn-style"
              >Add</a
            >
          </div>

          <div class="form-group form-inline">
            <label class="col-md-2">Default Value:</label>
            <select
              class="form-control form-control-sm col-md-4"
              v-model="formdata.default"
            >
              <option
                v-for="dds in DD_Selected"
                :value="dds.name"
                v-bind:key="dds.name"
              >
                {{ dds.label }}
              </option>
            </select>
          </div>
        </div>
        <div v-show="Relate">
          <!-- hidden datafield for relate -->
          

          <div class="form-group form-inline">
            <label class="col-md-2">Module:</label>
            <div>
              <DxSelectBox
                v-model="formdata.rmodule"
                :search-enabled="true"
                :data-source="modulelist"
                :search-mode="searchModeOption"
                :search-expr="searchExprOption"
                :search-timeout="searchTimeoutOption"
                :min-search-length="minSearchLengthOption"
                :show-data-before-search="showDataBeforeSearchOption"
                display-expr="label"
                value-expr="name"
                width="395"
                height="33"
                :disabled="editmode"
                @value-changed="onModuleValueChanged"
              />
            </div>
          </div>

          <div class="form-group form-inline">
            <label class="col-md-2">Filter On:</label>

            <div>
              <DxSelectBox
                v-model="formdata.filterOn"
                :search-enabled="true"
                :data-source="filterOnDataSource"
                :search-mode="searchModeOption"
                :search-expr="searchExprOption"
                :search-timeout="searchTimeoutOption"
                :min-search-length="minSearchLengthOption"
                :show-data-before-search="showDataBeforeSearchOption"
                value-expr="dataField"
                display-expr="label"
                width="395"
                height="33"
                @value-changed="onFilterOnValueChanged"
              />
            </div>
          </div>

          <div class="form-group form-inline">
            <label class="col-md-2">Filter Value:</label>

            <div>
              <DxDropDownBox
                v-model:value="gridBoxValue"
                v-model:opened="isGridBoxOpened"
                :defer-rendering="false"
                :show-clear-button="true"
                :data-source="filterValueDataSource"
                :value-expr="filterValExpr"
                display-expr="name"
                width="395"
                height="33"
                placeholder="Select a value..."
                @valueChanged="filterValueChanged"
              >
                <template #content="{ data }">
                  <DxDataGrid
                    :columns="gridColumns"
                    :data-source="filterValueDataSource"
                    :show-borders="true"
                    :showRowLines="true"
                    :remote-operations="true"
                    :hover-state-enabled="true"
                    v-model:selected-row-keys="gridBoxValue"
                    @selection-changed="onGridSelectionChanged($event)"
                    height="100%"
                  >
                    <DxSelection mode="multiple" />
                    <DxFilterRow :visible="true" />
                    <DxGroupPanel :visible="true" />
                    <DxGrouping :auto-expand-all="false" />
                    <DxPaging :page-size="10" />
                    <DxPager
                      :visible="true"
                      display-mode="full"
                      :show-page-size-selector="false"
                      :show-info="true"
                      :show-navigation-buttons="true"
                    />
                  </DxDataGrid>
                </template>
              </DxDropDownBox>
            </div>
          </div>
        </div>
        <div v-show="LineItemField">
          <div class="form-group form-inline">
            <label class="col-md-2">Related Modules:</label>

            <select
              class="form-control form-control-sm col-md-4"
              v-model="formdata.rmodule1"
              @change="onRelateValueChanged"
            >
              <option
                v-for="(element, key) in relatedModules"
                :key="key"
                :value="element"
              >
                <!-- {{ element.label }} -->
                {{ element }}
              </option>
            </select>
          </div>
        </div>
        <div v-show="InvoiceField">
          <div class="form-group form-inline">
            <label class="col-md-2">Module 1:</label>

            <select
              class="form-control form-control-sm col-md-4"
              v-model="formdata.rmodule1"
            >
              <option
                v-for="(element, key) in modulelist"
                :key="key"
                :value="element.name"
              >
                <!-- {{ element.label }} -->
                {{ element.name }}
              </option>
            </select>
          </div>
          <div class="form-group form-inline">
            <label class="col-md-2">Module 2:</label>

            <select
              class="form-control form-control-sm col-md-4"
              v-model="formdata.rmodule2"
            >
              <option
                v-for="(element, key) in modulelist"
                :key="key"
                :value="element.name"
              >
                <!-- {{ element.label }} -->
                {{ element.name }}
              </option>
            </select>
          </div>
        </div>

        <!-- common view -->
        <div v-show="TextField || Decimal || Float || Integer">
          <div class="form-group form-inline">
            <label class="col-md-2">Listener:</label>
            <input
              class="styled-checkbox"
              id="styled-checkbox-3"
              v-model="formdata.listener"
              type="checkbox"
              value="value2"
            />
            <label for="styled-checkbox-3"></label>
          </div>
        </div>
        <div v-show="formdata.listener">
          <div class="form-group form-inline">
            <label class="col-md-2"></label>
            <a
              @click="formulaBuilder"
              href="#"
              class="bg-gray-500 text-white text-xs hover:bg-gray-700 hover:no-underline ml-3 rounded link-btn-style"
              >Formula Builder</a
            >
          </div>
        </div>

        <div class="form-group form-inline">
          <label class="col-md-2">Required Field:</label>
          <input
            class="styled-checkbox"
            id="styled-checkbox-4"
            v-model="formdata.required"
            type="checkbox"
          />
          <label for="styled-checkbox-4"></label>
        </div>


          <div class="form-group form-inline">
            <label class="col-md-2">Source List:</label>
            <select
              class="form-control form-control-sm col-md-4"
              v-model="formdata.source"
            >
              <option value="db">DB Field</option>
              <option value="non-db">Non DB Field</option>

            </select>
           
          </div>

         
        <div
          v-show="
            TextField ||
            Json ||
            Checkbox ||
            Currency ||
            Date_tp ||
            Datetime ||
            Decimal ||
            Dropdown ||
            MultiSelect ||
            Float ||
            Integer ||
            Relate
          "
        >
          <div class="form-group form-inline">
            <label class="col-md-2">Mass Update:</label>
            <input
              class="styled-checkbox"
              id="styled-checkbox-3"
              v-model="formdata.massupdate"
              type="checkbox"
              value="value2"
            />
            <label for="styled-checkbox-3"></label>
          </div>

          <div class="form-group form-inline">
            <label class="col-md-2">Audit:</label>
            <input
              class="styled-checkbox"
              id="styled-checkbox-5"
              v-model="formdata.audited"
              type="checkbox"
              value="value1"
            />
            <label for="styled-checkbox-5"></label>
          </div>
          <div class="form-group form-inline">
            <label class="col-md-2">Importable:</label>
            <select
              class="form-control form-control-sm col-md-4"
              v-model="formdata.importable"
            >
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </div>
        </div>

        <div v-show="Datetime"></div>
        <div v-show="Float"></div>
        <div v-show="Integer">
          <div class="form-group form-inline">
            <label class="col-md-2">Sum of Field:</label>
            <input
              class="styled-checkbox"
              id="styled-checkbox-5"
              v-model="formdata.sum_of"
              type="checkbox"
            />
            <label for="styled-checkbox-5"></label>
          </div>
        </div>
        <div v-show="MultiSelect">10</div>
      </form>
    </div>
  </div>

  <DxPopup v-model:visible="fbPopupVisible">
    <template #content>
      <DxScrollView width="100%" height="100%">
        <div id="form-container">
          <DxForm
            id="form"
            :col-count="2"
            :form-data="listenerOptions"
            :items="items"
            label-location="top"
          >
            <template #form-tbl="{ data: item }">
              <div>
                <div
                  class="grid grid-cols-3 gap-4"
                  v-for="(flds, key) in listenerOptions.cal_fields"
                >
                  <div>{{ flds }}</div>
                  <div>
                    <code>{{ key }}</code>
                  </div>
                  <div>
                    <dx-button
                      @click="removeCalField(key)"
                      type="danger"
                      size="small"
                    >
                      Remove
                    </dx-button>
                  </div>
                </div>
                <div class="grid grid-cols-4 gap-4">
                  <div>
                    <DxSelectBox
                      v-model="formBuilder[item.dataField]"
                      :items="field_List1"
                      value-expr="name"
                      display-expr="label"
                    />
                  </div>
                  <div>
                    <DxButton @click="addCalField" text="Add" />
                  </div>
                </div>
              </div>
            </template>
            <template #form-tbl2="{ data: item }">
              <div>
                <div
                  class="grid grid-cols-4 gap-4"
                  v-for="(flds, key) in listenerOptions.relate_fields"
                >
                  <div>{{ flds }}</div>
                  <div>
                    <code>{{ key }}</code>
                  </div>
                  <div>
                    <dx-button
                      @click="removeRelateField(key)"
                      type="danger"
                      size="small"
                    >
                      Remove
                    </dx-button>
                  </div>
                </div>
                <div class="grid grid-cols-4 gap-4">
                  <div>
                    <DxSelectBox
                      v-model="formBuilder[item.dataField]['module']"
                      :items="modulelist"
                      value-expr="name"
                      display-expr="label"
                      :ref="ddlst"
                      @value-changed="getRelateFieldList"
                    />
                  </div>
                  <div>
                    <DxSelectBox
                      v-model="formBuilder[item.dataField]['field']"
                      :items="relate_fields"
                      value-expr="name"
                      display-expr="label"
                    />
                  </div>
                  <div>
                    <DxButton @click="addRelateField" text="Add" />
                  </div>
                </div>
              </div>
            </template>
          </DxForm>
        </div>
      </DxScrollView>
    </template>
    <DxToolbarItem
      widget="dxButton"
      toolbar="bottom"
      location="before"
      :options="saveButtonOptions"
    />
    <DxToolbarItem
      widget="dxButton"
      toolbar="bottom"
      location="after"
      :options="closeButtonOptions"
    />
  </DxPopup>
</template>
<script>
let activeTab = "dxTextBox";
import JetNavLink from "@/Jetstream/NavLink.vue";
import DxSelectBox from "devextreme-vue/select-box";
import DxButton from "devextreme-vue/button";
import { DxPopup, DxPosition, DxToolbarItem } from "devextreme-vue/popup";
import { DxScrollView } from "devextreme-vue/scroll-view";
import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import DxDropDownBox from "devextreme-vue/drop-down-box";
import { getRelate } from "@/Pages/Builder/base.js";
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxButtonItem,
  DxLabel,
} from "devextreme-vue/form";
import {
  DxDataGrid,
  DxSelection,
  DxPaging,
  DxFilterRow,
  DxScrolling,
  DxPager,
  DxGrouping,
  DxGroupPanel,
} from "devextreme-vue/data-grid";

export default {
  props: {
    modulekey: String,
    slug: String,
    studio: Boolean,
    tabData: {
      type: Object,
      default: () => ({}),
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    JetNavLink,
    DxPopup,
    DxForm,
    DxSimpleItem,
    DxToolbarItem,
    DxScrollView,
    DxGroupItem,
    DxButtonItem,
    DxSelectBox,
    DxLabel,
    DxButton,
    DxDataGrid,
    DxSelection,
    DxPaging,
    DxFilterRow,
    DxScrolling,
    DxPager,
    DxGrouping,
    DxGroupPanel,
    DxDropDownBox,
  },

  data() {
    const modulelistO = new CustomStore({
      key: "id",
      load: function (loadOptions) {
        var parameters = {};
        /* if (loadOptions.sort) {
                    parameters.order_column = loadOptions.sort[0].selector;
                    if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
                  }
                  parameters.filter = JSON.stringify(loadOptions.filter); */
        //parameters.skip = loadOptions.skip;
        //parameters.take = loadOptions.take;
        //parameters.page = (parameters.skip + parameters.take) / parameters.take;

        var config = {
          params: parameters,
        };
        //let listurl =  "/api/v1/module/list";
        let listurl = "/module/fulllist";
        return axios
          .get(listurl, config)
          .then((response) => {
            return {
              data: response.data.results,
            };
          })
          .catch(() => {
            throw "Data Loading Error";
          });
      },
    });
    return {
      formdata: { editorOptions: {}, validationRules: [], listener: false },
      formBuilder: { name: "", name2: {} },
      TextField: activeTab == "dxTextBox" ? true : false,
      Checkbox: activeTab == "Checkbox" ? true : false,
      Currency: activeTab == "Currency" ? true : false,
      Date_tp: activeTab == "Date_tp" ? true : false,
      Datetime: activeTab == "Datetime" ? true : false,
      Decimal: activeTab == "Decimal" ? true : false,
      Dropdown: activeTab == "dxSelectBox" ? true : false,
      Float: activeTab == "Float" ? true : false,
      Integer: activeTab == "Integer" ? true : false,
      MultiSelect: activeTab == "MultiSelect" ? true : false,
      Relate: activeTab == "Relate" ? true : false,
      Json: activeTab == "Json" ? true : false,
      LineItemField: activeTab == "LineItemField" ? true : false,
      RelateDependentField: activeTab == "RelateDependentField" ? true : false,
      BatchDialogField: activeTab == "BatchDialogField" ? true : false,
      ReportField: activeTab == "ReportField" ? true : false,
      InvoiceField: activeTab == "InvoiceField" ? true : false,
      TransactionField: activeTab == "TransactionField" ? true : false,

      editmode: this.edit,
      nameDisable: false,
      relatedModules: [],
      relateDef: {},
      DD_List: [],
      DD_Selected: [],
      field_List: new Object(),
      dependentOnList: [],
      dependentModuleList: [],
      field_List1: [],
      modulelist: [],
      modulelist1: [
        { name: "sdf", label: "sdf" },
        { name: "abc", label: "abc" },
      ],
      msize: 15,
      chk_dvalue: false,
      range_srh: false,
      dt_dvalue: "",
      prcsn: 2,
      dd_dvalue: "",
      mass_updt: false,
      required: false,
      audit: false,
      imprt: "no",
      form: {},
      fbPopupVisible: false,
      isGridBoxOpened: false,

      listenerOptions: {
        cal_fields: {},
        relate_fields: {},
        formula: "",
      },
      saveButtonOptions: {
        icon: "save",
        text: "Save",
        onClick: this.onSaveRelation,
      },
      closeButtonOptions: {
        text: "Close",
        onClick: () => {
          this.listenerOptions = {
            cal_fields: {},
            relate_fields: {},
            formula: "",
          };
          this.fbPopupVisible = false;
        },
      },
      ddlst: "ddlst",
      fields: [
        { name: "sdf", label: "sdf" },
        { name: "abc", label: "abc" },
      ],
      relate_fields: ["tarss", "varll"],
      items: [
        {
          name: "Basic",
          caption: "Fields",
          itemType: "group",
          items: [
            {
              dataField: "name",
              template: "form-tbl",
              label: {
                text: "Name",
              },
            },
            {
              dataField: "formula",
              editorType: "dxTextArea",
              label: {
                text: "Formula",
              },
            },
          ],
        },
        {
          name: "Basic",
          caption: "Relationship Fields",
          itemType: "group",
          items: [
            {
              dataField: "name2",
              template: "form-tbl2",
              label: {
                text: "Name",
              },
            },
          ],
        },
      ],
      addPhoneButtonOptions: {
        icon: "add",
        text: "Add",
        onClick: () => {
          //this.employee.Phones.push('');
        },
      },

      searchModeOption: "contains",
      searchExprOption: "name",
      searchTimeoutOption: 200,
      minSearchLengthOption: 0,
      filterOnDataSource: null,

      showDataBeforeSearchOption: true,
      rltSelectedModule: null,
      filterValueDataSource: null,
      filterValueArray: null,
      filterRltEditorType: null,
      gridColumns: ["name"],
      selectedFilterValue: null,
      filterValExpr: "id",
    };
  },
  watch: {
    "formdata.editorType": function (newValue) {
      if (newValue == "LineItemField") {
        this.LineItemField = true;
      }
    },
  },
  methods: {
    onChange(event) {
      activeTab = event.target.value; //console.log(activeTab);
      this.TextField = activeTab == "dxTextBox" ? true : false;
      this.Checkbox = activeTab == "Checkbox" ? true : false;
      this.Currency = activeTab == "Currency" ? true : false;
      this.Date_tp = activeTab == "Date_tp" ? true : false;
      this.Datetime = activeTab == "Datetime" ? true : false;
      this.Decimal = activeTab == "Decimal" ? true : false;
      this.Dropdown = activeTab == "dxSelectBox" ? true : false;
      this.Float = activeTab == "Float" ? true : false;
      this.Integer = activeTab == "Integer" ? true : false;
      this.MultiSelect = activeTab == "MultiSelect" ? true : false;
      this.Relate = activeTab == "Relate" ? true : false;
      this.Json = activeTab == "Json" ? true : false;
      this.InvoiceField = activeTab == "InvoiceField" ? true : false;
      this.LineItemField = activeTab == "LineItemField" ? true : false;
      this.BatchDialogField = activeTab == "BatchDialogField" ? true : false;
      this.ReportField = activeTab == "ReportField" ? true : false;

      (this.RelateDependentField =
        activeTab == "RelateDependentField" ? true : false),
        console.log("aara raara");
      if (activeTab === "TransactionField") {
        //   this.formdata.name = "transaction_series";
        //   this.isDisabled = true;
        //   this.formdata.vname = "LBL_TRANSACTION_SERIES"
        this.Relate = true;
      } else if (activeTab === "InvoiceField") {
        this.nameDisable = true;
        this.formdata.name = "inv_items";
      } else if (activeTab === "LineItemField") {
        this.nameDisable = true;
      } else {
        this.nameDisable = false;
      }
    },
    getDDList() {
      this.errors = {};
      axios
        .get("/dropdown/list")
        .then((response) => {
          this.DD_List = response.data.results.data;

          //alert("kk"+JSON.stringify(this.DD_List, null, 4));
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors || {};
          }
        });
    },
    getDropdown() {
      var val = this.formdata.options;

      var sldd = this.DD_List.filter(function (elem) {
        if (elem.name == val) return elem.options;
      });

      this.DD_Selected = sldd[0].options;
    },
    containsKey(obj, key) {
      return Object.keys(obj).includes(key);
    },
    editdropdown() {
      var val = this.formdata.options;
      var $data = this.DD_List.filter(function (elem) {
        if (elem.name == val) return elem.options;
      });

      //this.formdata.options
      this.$emit("send", {
        tabindex: 2,
        ddmode: true,
        ddData: $data[0],
      });
    },
    adddropdown() {
      this.$emit("send", {
        tabindex: 2,
      });
    },
    showfield(key) {
      this.editmode = true;
      var shdata = this.$root.$refs.fields_builder_list.field_List[key];

      //load the form data to edit
      this.formdata = shdata;

      //alert(this.containsKey(shdata,"name"));
      //alert("kk"+JSON.stringify(this.$root.$refs.field_list.field_List[key], null, 4));
    },
    getFieldslist() {
      this.errors = {};
      axios
        .get("/" + this.slug + "/field", {
          params: {
            module: this.modulekey,
            studio: this.studio,
          },
        })
        .then((response) => {
          this.field_List = response.data;

          console.log("dependentOnList response.data" , response.data);
          this.dependentOnList = Object.keys(response.data.deployed)
            .filter((key) => response.data.deployed[key].editorType === "Relate")
            .map((key) => ({
              label: response.data.deployed[key].label,
              value: key,
              rmodule: response.data.deployed[key],
            }));

          console.log(
            "Add Field builder dependentOnList",
            this.dependentOnList
          );
          /* const res = [];
                    for(let key in this.field_List){                        
                        res.push(this.field_List[key]);                       
                    } */
          this.field_List1 = this.objectToArrayFields(this.field_List);
        })
        .catch((error) => {
          if (error.response.status === 422) {
            console.log(error.response.message);
            this.errors = error.response.data.errors || {};
          }
          alert("error");
        });
    },
    objectToArrayFields(obj) {
      const res = [];
      for (let key in obj) {
        res.push(obj[key]);
      }
      return res;
    },
    filterOnObjectToArrayFields(obj) {
      const res = [];
      for (let key in obj) {
        res.push(obj[key]);
      }

      const newArray = res.map((obj) => ({
        name: obj.name,
        label: obj.label,
        editorType: obj.editorType,
        dataField: obj.dataField ? obj.dataField : obj.name,
      }));

      this.filterValueArray = newArray;
      return newArray;
    },

    getfieldName: function (event) {
      let lbl = "LBL_" + this.formdata.name.toUpperCase();
      this.formdata.vname = lbl;
      //console.log( this.formdata.vname);

      let displayLabel = this.formdata.name;
      let displayLabelWithSpace =
        displayLabel.charAt(0).toUpperCase() +
        displayLabel.slice(1).replace(/_/g, " ");
      this.formdata.label = displayLabelWithSpace.replace(
        /(^\w{1})|(\s+\w{1})/g,
        (letter) => letter.toUpperCase()
      );
    },

    getModuleList() {
      this.errors = {};

      axios
        .get("/" + this.slug + "/module/filterlist")
        .then((response) => {
          this.modulelist = response.data.results;
          // console.log("TEST UNFILTERMODULE",response.data.results );
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors || {};
          }
        });
    },
    getRelateModule() {
      console.log("LINE RELATED MODULE");
      getRelate(this.modulekey, this.studio, this.slug)
        .then((response) => {
          console.log("RESPONSE AA GYA", response.data);

          this.relateDef = response.data;

          let rNames = Object.values(response.data).map((item) => item.rmodule);
          this.relatedModules = rNames;
          console.log("LINE ITEM MODULE", this.relatedModules);
        })
        .catch((error) => {
          console.log("error");
        });
    },
    onRelateValueChanged(e) {
      this.formdata.name = this.formdata.rmodule1 + "_LineItem";
      if (this.formdata.editorType == "LineItemField") {
        let rNames = Object.values(this.relateDef).map((item) => item.name);
        this.formdata.relate_name = rNames[e.target.selectedIndex];
      }
    },
    onDependentValueChanged(e) {
      console.log("DependentModuleChange", e.value);
      let pModule = null;
      let searchModule = null;
      let rModule = e.value.rmodule;

      if ("pmodule" in e.value) {
        pModule = e.value.pmodule;
      }

      if (rModule == this.modulekey && pModule != null) {
        searchModule = pModule;
      } else {
        searchModule = rModule;
      }

      getRelate(searchModule, this.studio, this.slug)
        .then((response) => {
          // this.dependentModuleList = Object.keys(response.data)
          //   .filter((key) => response.data[key].pmodule === searchModule)
          //   .map((key) => response.data[key].rmodule);

          this.dependentModuleList = Object.keys(response.data).map((key) => {
            const currentItem = response.data[key];

            // Use rmodule if pmodule matches currentModule, otherwise use pmodule
            const moduleName =
              currentItem.pmodule === searchModule
                ? currentItem.rmodule
                : currentItem.pmodule;

            return {
              label: moduleName,
              value: currentItem,
            };
          });

          console.log(
            " onDependentValueChanged dependentModuleList ",
            this.dependentModuleList
          );

          //console.log(" onDependentValueChanged RESPONSE ", response.data);
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getRelateFieldList(event) {
      let selectedModule = event.value;
      this.errors = {};
      axios
        .get("/field", {
          params: {
            module: selectedModule,
            studio: this.studio,
          },
        })
        .then((response) => {
          this.relate_fields = this.objectToArrayFields(response.data);
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors || {};
          }
        });
    },
    updateField() {
      if (this.formdata.editorType == "Relate") {
        this.formdata.filterValue = this.selectedFilterValue;
      }
      this.$inertia.put(route("field.update", [this.slug, "sds"]), {
        _method: "put",
        data: "ss",
        module: this.modulekey,
        studio: this.studio,
        data: this.formdata,
      });
    },
    saveField() {
      //if relate then add
      this.errors = {};
      if (this.formdata.editorType == "Relate") {

        this.formdata.dataField = this.formdata.dataField ? this.formdata.dataField: this.formdata.name;
        
        this.formdata.name = "rlt_fld_" + this.formdata.name;
        
        this.formdata.filterValue = this.selectedFilterValue;
        // this.formdata.filterValue = this.selectFilterValue;
      }

      console.log("Formdata  Field",this.formdata);


       axios
         .post("/" + this.slug + "/field", {
           module: this.modulekey,
           studio: this.studio,
           data: this.formdata,
         })
         .then((response) => {
           window.location.href =
             "/" + this.slug + "/module/" + this.modulekey + "/fields";
         })
         .catch((error) => {
          if (error.response.status === 422) {
             this.errors = error.response.data.errors || {};
          }
        });


    },
    clear() {
      this.editmode = false;
      (this.formdata = { editorOptions: {}, validationRules: [] }),
        this.$emit("send", {
          tabindex: 0,
        });
    },
    deletefld() {
      console.log("delete data", this.formdata);
      let params = {
        module: this.modulekey,
        studio: this.studio,
        data: this.formdata,
      };
      axios
        .delete("/" + this.slug + "/field/" + this.formdata.name, {
          data: params,
        })
        .then((response) => {
          //this.DD_List = response.data;
          // this.$root.$refs.fields_builder_list.getFieldslist();
          // this.cancel();
          window.location.href =
            "/" + this.slug + "/module/" + this.modulekey + "/fields";
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors || {};
          }
        });
    },
    cancel() {
      //alert("doone");
      this.clear();
      /* $(".nav-tabs > li > a#add_field-tab > span").trigger('click'); */
    },
    getFormData() {
      //formdata.module = this.modulekey;
      // alert("kk"+this.dtype);
    },
    formulaBuilder() {
      //alert("formula builder");
      this.fbPopupVisible = true;
    },
    addCalField() {
      var count = Object.keys(this.listenerOptions.cal_fields).length;

      this.listenerOptions.cal_fields["P" + count] = this.formBuilder["name"];
    },
    removeCalField(key) {
      delete this.listenerOptions.cal_fields[key];
    },
    addRelateField() {
      var count = Object.keys(this.listenerOptions.relate_fields).length;

      this.listenerOptions.relate_fields["RP" + count] =
        this.formBuilder["name2"];
    },
    removeRelateField(key) {
      delete this.listenerOptions.relate_fields[key];
    },
    onSaveRelation() {
      this.formdata.listenerOptions = this.listenerOptions;
      this.fbPopupVisible = false;
    },
    onModuleValueChanged(e) {
      this.errors = {};
      this.rltSelectedModule = e.value;
      axios
        .get("/" + this.slug + "/field", {
          params: {
            module: e.value,
            studio: this.studio,
          },
        })
        .then((response) => {
          this.filterOnDataSource = this.filterOnObjectToArrayFields(
            response.data
          );
        })
        .catch((error) => {
          if (error.response.status === 422) {
            console.log(error.response.message);
            this.errors = error.response.data.errors || {};
          }
          alert("error");
        });
    },
    onFilterOnValueChanged(e) {
      this.errors = {};

      console.log("onFilterOnValueChanged", e.value);

      const arryVal = this.filterValueArray.find(
        (item) => item.dataField === e.value
      );

      //this.filterValExpr = "name";

      this.filterRltEditorType = arryVal.editorType;
      this.filterValueDataSource = this.makeAsyncDataSource(
        this.rltSelectedModule,
        e.value,
        arryVal.editorType,
        arryVal.label,
        this.slug
      );
    },

    makeAsyncDataSource(module, field, editorType, label, slug) {
      return new CustomStore({
        loadMode: "raw",
        key: "id",

        load: function (loadOptions) {
          let listurl = "/" + slug + "/fields/getRelatedFilterValue";

          var parameters = {
            module: module,
            field: field,
            editorType: editorType,
            label: label,
          };

          if (loadOptions.sort) {
            parameters.order_column = loadOptions.sort[0].selector;
            if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
          }
          parameters.group = JSON.stringify(loadOptions.group);
          parameters.filter = JSON.stringify(loadOptions.filter);
          parameters.skip = loadOptions.skip;
          parameters.take = loadOptions.take;
          parameters.page =
            (parameters.skip + parameters.take) / parameters.take;
          var config = {
            params: parameters,
          };
          return axios
            .get(listurl, config)
            .then((response) => {
              return response.data;
            })
            .catch(() => {
              throw "Data Loading Error";
            });
        },
      });
    },
    onGridSelectionChanged(item) {
      if (item.selectedRowsData.length >= 1) {
        // console.log("onGridSelectionChanged",item.selectedRowsData[0])

        //this.selectFilterValue.push(item.selectedRowsData[0].name)

        this.selectedRecord = item.selectedRowsData[0].id;
        this.$emit("update:modelValue", item.selectedRowsData[0].id);
      }

      // this.isGridBoxOpened = false;
    },
    filterValueChanged(event) {
      this.selectedFilterValue = event.value;
      console.log("flilterValueChanged ", event.value);
    },
  },
  created: function () {
    //console.log('Created');
    this.getDDList();
    this.getModuleList();
    this.getFieldslist();
    this.getRelateModule();
    this.tabData.editorOptions = {};
    this.tabData.validationRules = [];
    this.formdata = this.tabData;
  },

  mounted: function () {
    // console.log("Component mounted.", this.editmode);
    console.log("EDIT TESTING", this.formdata.name);
    if (this.editmode == true) {
      //check if edit field is custom  and slug is studio

      if (
        this.formdata.editorType == "Relate" ||
        this.formdata.editorType == "TransactionField"
      ) {
        this.Relate = "Relate" ? true : false;
        var initialValue = this.formdata.rmodule;
        if (this.modulekey == this.formdata.rmodule) {
          initialValue = this.formdata.pmodule;
        }

        this.onModuleValueChanged({ value: initialValue });
      }
    }

    if (this.editmode == false) {
      this.formdata.editorOptions.precision = this.prcsn;
    }
  },
};
</script>
<style scoped>
.link-btn-style {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>